.description-container {
  text-align: center;
}

gz-text:first-of-type {
  margin-bottom: calc(var(--spacer) * 2);
}

.loading-section {
  width: 100%;
}

gz-gauge {
  max-width: 340px;
  min-width: 340px;
}
